export function range(s: number, e: number) {
	return Array.from({ length: e - s + 1 }, (_, i) => s + i)
}
